import * as React from "react";
import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { Text } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { isNewPrescriptionAndUpload } from "../../../../utils/utils/is-new-prescription-upload.js";
import { PrescriptionCard } from "../../PrescriptionCard/components/PrescriptionSummary/PrescriptionCard/PrescriptionCard.js";
import { PrescriptionTable } from "../../PrescriptionTable/components/PrescriptionSummary/PrescriptionTable/PrescriptionTable.js";
import { PrescriptionUploadSummary } from "../../PrescriptionUploadSummary/components/PrescriptionSummary/PrescriptionUploadSummary/PrescriptionUploadSummary.js";
const PrescriptionSummary = ({
  parameters,
  right,
  left,
  prescriptionType,
  uploadReferences,
  className
}) => {
  const { getLabel, hasLabel } = useIntl();
  const hasRx = Object.keys(right).length > 0 || Object.keys(left).length > 0;
  const hasUpload = uploadReferences && Object.keys(uploadReferences).length > 0;
  if (CommerceToolsApi.isPrescriptionFile(prescriptionType) && hasUpload) {
    return /* @__PURE__ */ React.createElement(PrescriptionCard, { hideTitle: true, className }, /* @__PURE__ */ React.createElement(PrescriptionUploadSummary, { uploadReferences }));
  }
  const hasData = hasRx || hasUpload;
  if (isNewPrescriptionAndUpload(prescriptionType) && hasData) {
    return /* @__PURE__ */ React.createElement(PrescriptionCard, { className }, hasRx && /* @__PURE__ */ React.createElement(PrescriptionTable, { left, right, parameters }), uploadReferences && /* @__PURE__ */ React.createElement(PrescriptionUploadSummary, { uploadReferences }));
  }
  if (CommerceToolsApi.isNewPrescription(prescriptionType) && hasRx) {
    return /* @__PURE__ */ React.createElement(PrescriptionCard, { className }, /* @__PURE__ */ React.createElement(PrescriptionTable, { left, right, parameters }));
  }
  const existingCustomerLabel = "products.glasses.configurator.footer.existingCustomer";
  if (CommerceToolsApi.isExistingCustomer(prescriptionType) && hasLabel(existingCustomerLabel)) {
    return /* @__PURE__ */ React.createElement(PrescriptionCard, { className }, /* @__PURE__ */ React.createElement(Text, { variant: "caption" }, getLabel(existingCustomerLabel)));
  }
  const emailPrescriptionLabel = "products.glasses.configurator.footer.emailPrescription";
  if (CommerceToolsApi.isEmailPrescription(prescriptionType) && hasLabel(emailPrescriptionLabel)) {
    return /* @__PURE__ */ React.createElement(PrescriptionCard, { className }, /* @__PURE__ */ React.createElement(Text, { variant: "caption" }, getLabel(emailPrescriptionLabel)));
  }
  return null;
};
export {
  PrescriptionSummary
};
//# sourceMappingURL=PrescriptionSummary.js.map
